import React from 'react';
import ReportsTable from 'components/reports/ReportsTable';

const ReportsPage = () => {
  return <ReportsTable />;
};

export default ReportsPage;
